<template>
  <footer class="bg-dark text-light py-4 mt-auto">
    <div class="container">
      <div class="row align-items-center gy-3">

        <!-- Logo and Copyright -->
        <div class="col-lg-4 col-md-12 text-center text-lg-start mb-3 mb-lg-0">
          <img src="@/assets/logoMainNav-dark.webp" alt="Medicynia Logo" height="60" class="mb-2">
          <p class="small text-light mb-0">&copy; 2025 Medicynia. Todos los derechos reservados. <br>
            Desarrollado con 
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="var(--eb-primary)" viewBox="0 0 16 16" style="vertical-align:middle;">
              <path d="M8 14s5-3.33 5-7.5A3.5 3.5 0 0 0 8 3a3.5 3.5 0 0 0-5 3.5C3 10.67 8 14 8 14z"/>
            </svg>
            para la comunidad médica.

          </p>
        </div>

        <!-- Navigation Links -->
        <div class="col-lg-4 col-md-6 text-center">
          <ul class="list-inline mb-0">
            <li class="list-inline-item me-3">
              <router-link to="/" class="text-light text-light">Inicio</router-link>
            </li>
            <li class="list-inline-item me-3">
              <a href="#features" @click.prevent="scrollTo('features', true)" class="text-light">Características</a>
            </li>
            <li class="list-inline-item">
              <a href="#pricing" @click.prevent="scrollTo('pricing', true)"  class="text-light">Precios</a>
            </li>
             <li class="list-inline-item ">
              <a href="https://app.medicynia.com/" class="text-light">Iniciar Sesión</a>
            </li>
             <li class="list-inline-item">
              <router-link to="/signup" class="text-light">Registrarse</router-link>
            </li>
          </ul>
        </div>

        <!-- Powered by Stripe & Legal Links -->
        <div class="col-lg-4 col-md-6 text-center text-lg-end">
           <div class="mb-2">
             <span class="small text-light me-2">Powered by</span>
             <img src="@/assets/stripe.svg" alt="Stripe Logo" height="30">
           </div>
           <div>
             <router-link to="/privacy-policy" class="text-light small me-3">Política de Privacidad</router-link>
             <router-link to="/terms-conditions" class="text-light small">Términos y condiciones</router-link>
           </div>
        </div>

      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  /**
   * 
   */
  methods: {
    scrollTo(sectionId, fromMobile = false) {
      // Simplificar: Dejar que el scroll-padding-top global maneje el offset
      if (this.$route.path === '/') {
        const element = document.getElementById(sectionId);
        if (element) {
          // Esperar que el menú se cierre si viene de móvil
          // Bootstrap collapse puede necesitar un poco más de tiempo
          setTimeout(() => {
            element.scrollIntoView({ behavior: 'smooth' });
          }, fromMobile ? 300 : 0); // Aumentar timeout si es necesario
        }
      } else {
        // Navegar a la home y luego hacer scroll
        this.$router.push('/').then(() => {
           this.$nextTick(() => {
             const element = document.getElementById(sectionId);
             if (element) {
                setTimeout(() => {
                    element.scrollIntoView({ behavior: 'smooth' });
                }, 100); // Pequeño delay para asegurar que la página está renderizada
             }
           });
        });
      }
    }
    
  }

}
</script>

<style scoped>
footer a {
  text-decoration: none;
  color: var(--bs-light) !important; /* Ensure links are light */
  transition: color 0.2s ease-in-out;
}
footer a:hover {
  text-decoration: none; /* Remove underline on hover if desired */
  color: var(--eb-primary) !important; /* Use primary color on hover */
}

.list-inline-item a {
   font-size: 0.9rem;
}

.small {
  font-size: 0.8rem;
}

img {
  vertical-align: middle; /* Align stripe logo better with text */
}
</style>
